var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_course",style:({
        'background-image':
        'url(' +
        require(("@/assets/images/flags/" + _vm.imageSource + ".svg")) +
        ')'
    })})}
var staticRenderFns = []

export { render, staticRenderFns }